import { render, staticRenderFns } from "./MainPerformance.vue?vue&type=template&id=f0684b10&scoped=true"
import script from "./MainPerformance.vue?vue&type=script&lang=js"
export * from "./MainPerformance.vue?vue&type=script&lang=js"
import style0 from "./MainPerformance.vue?vue&type=style&index=0&id=f0684b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0684b10",
  null
  
)

export default component.exports